<div class="animate-slideFromRight"><ng-content></ng-content></div>
